"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorization = exports.AuthorizationGrant = void 0;
var json_1 = require("../../../util/json");
var GenericAuthorization_1 = require("./GenericAuthorization");
var SendAuthorization_1 = require("./SendAuthorization");
var StakeAuthorization_1 = require("./StakeAuthorization");
var authz_1 = require("@terra-money/terra.proto/cosmos/authz/v1beta1/authz");
var AuthorizationGrant = /** @class */ (function (_super) {
    __extends(AuthorizationGrant, _super);
    function AuthorizationGrant(authorization, expiration) {
        var _this = _super.call(this) || this;
        _this.authorization = authorization;
        _this.expiration = expiration;
        return _this;
    }
    AuthorizationGrant.fromAmino = function (amino) {
        var authorization = amino.authorization, expiration = amino.expiration;
        return new AuthorizationGrant(Authorization.fromAmino(authorization), new Date(expiration));
    };
    AuthorizationGrant.prototype.toAmino = function () {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return {
            authorization: authorization.toAmino(),
            expiration: expiration.toISOString().replace(/\.000Z$/, 'Z'),
        };
    };
    AuthorizationGrant.fromData = function (data) {
        var authorization = data.authorization, expiration = data.expiration;
        return new AuthorizationGrant(Authorization.fromData(authorization), new Date(expiration));
    };
    AuthorizationGrant.prototype.toData = function () {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return {
            authorization: authorization.toData(),
            expiration: expiration.toISOString().replace(/\.000Z$/, 'Z'),
        };
    };
    AuthorizationGrant.fromProto = function (proto) {
        return new AuthorizationGrant(Authorization.fromProto(proto.authorization), proto.expiration);
    };
    AuthorizationGrant.prototype.toProto = function () {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return authz_1.Grant.fromPartial({
            authorization: authorization.packAny(),
            expiration: expiration,
        });
    };
    return AuthorizationGrant;
}(json_1.JSONSerializable));
exports.AuthorizationGrant = AuthorizationGrant;
var Authorization;
(function (Authorization) {
    function fromAmino(data) {
        switch (data.type) {
            case 'msgauth/SendAuthorization':
                return SendAuthorization_1.SendAuthorization.fromAmino(data);
            case 'msgauth/GenericAuthorization':
                return GenericAuthorization_1.GenericAuthorization.fromAmino(data);
        }
    }
    Authorization.fromAmino = fromAmino;
    function fromData(data) {
        switch (data['@type']) {
            case '/cosmos.authz.v1beta1.GenericAuthorization':
                return GenericAuthorization_1.GenericAuthorization.fromData(data);
            case '/cosmos.bank.v1beta1.SendAuthorization':
                return SendAuthorization_1.SendAuthorization.fromData(data);
            case '/cosmos.staking.v1beta1.StakeAuthorization':
                return StakeAuthorization_1.StakeAuthorization.fromData(data);
        }
    }
    Authorization.fromData = fromData;
    function fromProto(proto) {
        var typeUrl = proto.typeUrl;
        switch (typeUrl) {
            case '/cosmos.authz.v1beta1.GenericAuthorization':
                return GenericAuthorization_1.GenericAuthorization.unpackAny(proto);
            case '/cosmos.bank.v1beta1.SendAuthorization':
                return SendAuthorization_1.SendAuthorization.unpackAny(proto);
            case '/cosmos.staking.v1beta1.StakeAuthorization':
                return StakeAuthorization_1.StakeAuthorization.unpackAny(proto);
        }
        throw new Error("Authorization type " + typeUrl + " not recognized");
    }
    Authorization.fromProto = fromProto;
})(Authorization = exports.Authorization || (exports.Authorization = {}));
//# sourceMappingURL=Authorization.js.map